<div class="editor">
  <input #input
         type="number"
         (keydown)="onKeyDown($event)"
         (blur)="onBlur($event)"
         [(ngModel)]="params.value"
         [minlength]="params?.column?.colDef?.minlength"
         [maxlength]="params?.column?.colDef?.maxlength">
</div>
